import * as React from "react";
import styled, { css } from "styled-components";
import { Label } from "components/bootstrap";
const Container = styled.div(
  ({ theme }) => css`
    display: inline-flex;
    gap: ${theme.spacings.xs};
    flex-wrap: wrap;
  `
);
const TagList = ({ tags, emptyFallback = null }) => {
  if (!(tags == null ? void 0 : tags.length)) {
    return emptyFallback != null ? emptyFallback : null;
  }
  return /* @__PURE__ */ React.createElement(Container, null, [...tags].sort().map((tag) => /* @__PURE__ */ React.createElement(Label, { key: tag, bsStyle: "default" }, tag)));
};
export default TagList;
